<template>
  <div class="flexBox">
    <!-- column#1 -->
    <div class="flexInner">
      <!-- 이름 -->
      <div class="innerItem">
        <p class="innerTitle setLabel">{{locale.reservation_space_name}}</p>
        <div class="translation">
          <input v-model="info.name[lang.default]" type="text" class="input" @focusout="setDefaultVal('info', info.id, 'name')">
          <button type="button" class="btnTranslation" :title="locale.language_specific_set" @click.stop="onLangValueOpen()">
            <span class="blind">{{locale.language_specific_set}}</span>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="512" height="512"><g id="outline"><path d="M71.008,183.859,99,206.25A8,8,0,0,0,112,200V176h34c-.1.146-.226.283-.329.43a136.11,136.11,0,0,0,57.883,205.109c.211.086.429.164.648.234A135.616,135.616,0,0,0,256,392a137.9,137.9,0,0,0,24-2.129V440a32.032,32.032,0,0,0,32,32H424a32.032,32.032,0,0,0,32-32V367.383a39.852,39.852,0,0,0-15.008-31.242L413,313.75A8,8,0,0,0,400,320v24H359.5c2.225-2.613,4.472-5.211,6.491-7.976.031-.04.064-.076.1-.117s.057-.067.083-.1A136.03,136.03,0,0,0,256,120a137.9,137.9,0,0,0-24,2.129V80a32.032,32.032,0,0,0-32-32H88A32.032,32.032,0,0,0,56,80v72.617A39.852,39.852,0,0,0,71.008,183.859ZM408,360a8,8,0,0,0,8-8V336.641l14.992,11.992A23.906,23.906,0,0,1,440,367.383V440a16.021,16.021,0,0,1-16,16H312a16.021,16.021,0,0,1-16-16V376a16.021,16.021,0,0,1,16-16Zm-85.725-16q1.952-7.046,3.563-14.112Q335.9,332.2,346,335.273c-2.692,3.055-5.56,5.948-8.55,8.727Zm34.063-22.282q-13.658-4.4-27.277-7.5A324.916,324.916,0,0,0,334.2,264h41.5A119.068,119.068,0,0,1,356.338,321.718Zm.145-131.214A118.789,118.789,0,0,1,375.691,248H334.2a323.384,323.384,0,0,0-5.125-50.036Q342.938,194.822,356.483,190.5Zm-10.277-13.583q-10.067,3.023-20.317,5.362-3.323-14.64-8.128-29.137A119.3,119.3,0,0,1,346.206,176.921ZM264,136.314a119.479,119.479,0,0,1,33.258,7.09,298.5,298.5,0,0,1,12.961,42.11A310.41,310.41,0,0,1,264,190.167Zm0,69.881a326.175,326.175,0,0,0,49.4-5,307.007,307.007,0,0,1,4.8,46.8H264ZM264,264H318.2a308.575,308.575,0,0,1-4.8,46.941A326.084,326.084,0,0,0,264,305.829Zm0,57.831a310.731,310.731,0,0,1,46.176,4.783q-2.089,9.087-4.726,18.071a31.955,31.955,0,0,0-25.195,28.8A118.573,118.573,0,0,1,264,375.64ZM155.512,190.512q12.942,4.15,25.833,7.111A325.253,325.253,0,0,0,176.2,248H136.309A118.879,118.879,0,0,1,155.512,190.512Zm10.257-13.577q.415-.468.838-.935h19.317c-.5,2-.951,3.96-1.406,5.941Q175.164,179.765,165.769,176.935ZM155.384,321.26A118.849,118.849,0,0,1,136.308,264h39.9a324.516,324.516,0,0,0,5.138,50.2Q168.435,317.155,155.384,321.26Zm10.259,13.609q9.494-2.819,18.891-4.982,3.207,14.038,7.67,27.719A120.364,120.364,0,0,1,165.643,334.869ZM248,375.671a121.547,121.547,0,0,1-35.183-7.794,298.271,298.271,0,0,1-12.623-41.254A302.426,302.426,0,0,1,248,321.765Zm0-69.86a332.354,332.354,0,0,0-50.989,5.142A307.941,307.941,0,0,1,192.2,264H248ZM248,248H192.2a308.706,308.706,0,0,1,4.8-47.084A325.631,325.631,0,0,0,248,206.191ZM232,144v-5.54a118.972,118.972,0,0,1,16-2.106v53.814a309.782,309.782,0,0,1-47.824-4.93q1.1-4.733,2.369-9.5A31.932,31.932,0,0,0,232,144ZM72,80A16.021,16.021,0,0,1,88,64H200a16.021,16.021,0,0,1,16,16v64a16.021,16.021,0,0,1-16,16H104a8,8,0,0,0-8,8v15.359L81.008,171.367A23.906,23.906,0,0,1,72,152.617Z"/><circle cx="144" cy="108" r="12"/><circle cx="188" cy="108" r="12"/><circle cx="100" cy="108" r="12"/><circle cx="368" cy="412" r="12"/><circle cx="412" cy="412" r="12"/><circle cx="324" cy="412" r="12"/></g></svg>
          </button>
        </div>
      </div>
      <!-- //이름 -->
      <!-- 예약자 정보 -->
      <div class="innerItem">
        <p class="innerTitle setLabel">{{locale.reservation_required_input}}</p>
        <p class="sysMessage">{{locale.reservation_message_required_input}}</p>
        <!-- <div class="mb15">
          <span class="checkbox disabled">
            <input type="checkbox" id="reserver_name" checked disabled v-model="info.bookerName">
            <label for="reserver_name">{{locale.reservation_booker_name}} <i class="colorPrimary">*</i></label>
          </span>
        </div> -->
        <div class="mt10">
          <span class="checkbox">
            <input type="checkbox" id="reserver_tel" :disabled="!info.bookerEmail && !info.bookerTelOrEmail" @change="setUserInfo('bookerTel')" v-model="info.bookerTel">
            <label for="reserver_tel">{{locale.reservation_booker_tel}}</label>
          </span>
        </div>
        <div class="mt10">
          <span class="checkbox">
            <input type="checkbox" id="reserver_email" :disabled="!info.bookerTel && !info.bookerTelOrEmail" @change="setUserInfo('bookerEmail')" v-model="info.bookerEmail">
            <label for="reserver_email">{{locale.reservation_booker_email}}</label>
          </span>
        </div>
        <div class="mt10">
          <span class="checkbox">
            <input type="checkbox" id="reserver_tel_or_email" :disabled="!info.bookerEmail && !info.bookerTel" @change="setUserInfo('bookerTelOrEmail')" v-model="info.bookerTelOrEmail">
            <label for="reserver_tel_or_email">예약자 전화번호 또는 이메일</label>
          </span>
        </div>
        <!-- <div class="mb15">
          <span class="checkbox">
            <input type="checkbox" id="reserver_memo" v-model="info.bookerMemo">
            <label for="reserver_memo">예약자 메모</label>
          </span>
        </div> -->
      </div>
      <!-- //예약자 정보 -->
      <!-- 추가 정보 -->
      <div class="innerItem">
        <p class="innerTitle setLabel">추가 입력 정보 설정</p>
        <p class="sysMessage">예약자 필수입력 정보 외 필요한 입력정보가 있다면 추가해주세요.</p>
        <div class="mt10">
          <button type="button" class="btn btnWhite" @click.stop="setAdditionalInfo(true)">
            {{ `${locale.setting} (${info.additionalInfo?.length})` }}
          </button>
        </div>
        <!-- <div class="mt10">
          <button type="button" class="btn btnWhite" @click.stop="addAdditionalInfo">
            {{ locale.add_registration_info }}
          </button>
        </div>
        <div v-if="additionalInfo.length > 0" class="mt10">
          <div v-for="(infoItem, index) in additionalInfo"
            :key="infoItem.id"
            class="additionalInfoItem">
            <button type="button" class="btnDel" @click.stop="removeAdditionlInfo(index)"></button>
            <div class="checkbox mb5">
              <input type="checkbox" :id="`additionalInfo_item_${infoItem.id}`" v-model="infoItem.isRequired">
              <label :for="`additionalInfo_item_${infoItem.id}`">{{ locale.required }}</label>
            </div>
            <SetLanguageValue
              :locale="locale"
              :langValue="infoItem.label" />
          </div>
        </div> -->

      </div>
      <!-- //추가 정보 -->
      <!-- 예약정보 입력 -->
      <div class="innerItem">
        <p class="innerTitle setLabel">{{locale.reservation_information_input}}</p>
        <div class="translation">
          <textarea class="input" row="5" v-model="info.infoTxt[lang.default]" @focusout="setDefaultVal('infoTxt', info.id, 'infoTxt')"></textarea>
          <button type="button" class="btnTranslation" :title="locale.language_specific_set" @click.stop="onLangValueOpen('info')">
            <span class="blind">{{locale.language_specific_set}}</span>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="512" height="512"><g id="outline"><path d="M71.008,183.859,99,206.25A8,8,0,0,0,112,200V176h34c-.1.146-.226.283-.329.43a136.11,136.11,0,0,0,57.883,205.109c.211.086.429.164.648.234A135.616,135.616,0,0,0,256,392a137.9,137.9,0,0,0,24-2.129V440a32.032,32.032,0,0,0,32,32H424a32.032,32.032,0,0,0,32-32V367.383a39.852,39.852,0,0,0-15.008-31.242L413,313.75A8,8,0,0,0,400,320v24H359.5c2.225-2.613,4.472-5.211,6.491-7.976.031-.04.064-.076.1-.117s.057-.067.083-.1A136.03,136.03,0,0,0,256,120a137.9,137.9,0,0,0-24,2.129V80a32.032,32.032,0,0,0-32-32H88A32.032,32.032,0,0,0,56,80v72.617A39.852,39.852,0,0,0,71.008,183.859ZM408,360a8,8,0,0,0,8-8V336.641l14.992,11.992A23.906,23.906,0,0,1,440,367.383V440a16.021,16.021,0,0,1-16,16H312a16.021,16.021,0,0,1-16-16V376a16.021,16.021,0,0,1,16-16Zm-85.725-16q1.952-7.046,3.563-14.112Q335.9,332.2,346,335.273c-2.692,3.055-5.56,5.948-8.55,8.727Zm34.063-22.282q-13.658-4.4-27.277-7.5A324.916,324.916,0,0,0,334.2,264h41.5A119.068,119.068,0,0,1,356.338,321.718Zm.145-131.214A118.789,118.789,0,0,1,375.691,248H334.2a323.384,323.384,0,0,0-5.125-50.036Q342.938,194.822,356.483,190.5Zm-10.277-13.583q-10.067,3.023-20.317,5.362-3.323-14.64-8.128-29.137A119.3,119.3,0,0,1,346.206,176.921ZM264,136.314a119.479,119.479,0,0,1,33.258,7.09,298.5,298.5,0,0,1,12.961,42.11A310.41,310.41,0,0,1,264,190.167Zm0,69.881a326.175,326.175,0,0,0,49.4-5,307.007,307.007,0,0,1,4.8,46.8H264ZM264,264H318.2a308.575,308.575,0,0,1-4.8,46.941A326.084,326.084,0,0,0,264,305.829Zm0,57.831a310.731,310.731,0,0,1,46.176,4.783q-2.089,9.087-4.726,18.071a31.955,31.955,0,0,0-25.195,28.8A118.573,118.573,0,0,1,264,375.64ZM155.512,190.512q12.942,4.15,25.833,7.111A325.253,325.253,0,0,0,176.2,248H136.309A118.879,118.879,0,0,1,155.512,190.512Zm10.257-13.577q.415-.468.838-.935h19.317c-.5,2-.951,3.96-1.406,5.941Q175.164,179.765,165.769,176.935ZM155.384,321.26A118.849,118.849,0,0,1,136.308,264h39.9a324.516,324.516,0,0,0,5.138,50.2Q168.435,317.155,155.384,321.26Zm10.259,13.609q9.494-2.819,18.891-4.982,3.207,14.038,7.67,27.719A120.364,120.364,0,0,1,165.643,334.869ZM248,375.671a121.547,121.547,0,0,1-35.183-7.794,298.271,298.271,0,0,1-12.623-41.254A302.426,302.426,0,0,1,248,321.765Zm0-69.86a332.354,332.354,0,0,0-50.989,5.142A307.941,307.941,0,0,1,192.2,264H248ZM248,248H192.2a308.706,308.706,0,0,1,4.8-47.084A325.631,325.631,0,0,0,248,206.191ZM232,144v-5.54a118.972,118.972,0,0,1,16-2.106v53.814a309.782,309.782,0,0,1-47.824-4.93q1.1-4.733,2.369-9.5A31.932,31.932,0,0,0,232,144ZM72,80A16.021,16.021,0,0,1,88,64H200a16.021,16.021,0,0,1,16,16v64a16.021,16.021,0,0,1-16,16H104a8,8,0,0,0-8,8v15.359L81.008,171.367A23.906,23.906,0,0,1,72,152.617Z"/><circle cx="144" cy="108" r="12"/><circle cx="188" cy="108" r="12"/><circle cx="100" cy="108" r="12"/><circle cx="368" cy="412" r="12"/><circle cx="412" cy="412" r="12"/><circle cx="324" cy="412" r="12"/></g></svg>
          </button>
        </div>
      </div>
      <!-- //예약정보 입력 -->
      <!-- 예약취소 -->
      <div class="innerItem">
        <p class="innerTitle setLabel">{{locale.reservation_cancel_setting}}</p>
        <span class="checkbox">
          <input type="checkbox" id="possible_cancel" v-model="info.cancel">
          <label for="possible_cancel" class="label">{{locale.reservation_cancellable}}</label>
        </span>
        <div class="mt5">
          <input type="text" class="input sizeS" v-model="info.cancelDay" @input="inputNumber('info', 'cancelDay')"> {{locale.day}}
          <span v-if="info.cancelDay === 0" class="ml15">
            <input type="text" class="input sizeS" v-model="info.cancelTime" @input="inputNumber('info', 'cancelTime')"> {{locale.minute}}
          </span>
        </div>
      </div>
      <!-- //예약취소 -->
    </div>
    <!-- //column#1 -->
    <!-- column#2 -->
    <div class="flexInner">
      <!-- 날짜 -->
      <div class="innerItem">
        <p class="innerTitle setLabel">{{locale.reservation_date_setting}}</p>
        <div class="flexBox mb15">
          <!-- 오늘 선택 가능 여부 -->
          <div class="flexInner">
            <label class="label colorGrey">{{locale.today}}</label>
            <span class="ml10 checkbox onoff">
              <input type="checkbox"
                id="calendar_allowed_today"
                v-model="info.allowedToday">
              <label for="calendar_allowed_today">{{info.allowedToday ? locale.selectable : locale.not_selectable}}</label>
            </span>
          </div>
          <!-- //오늘 선택 가능 여부 -->
        </div>
        <!-- 예약가능일자 범위 -->
        <div class="mb15">
          <label class="label colorGrey">{{locale.reservation_date_range}}</label>
          <div>
            <input type="text" class="input sizeS" v-model="info.range" @input="inputNumber('info', 'range')"> {{locale.day}}
          </div>
        </div>
        <!-- //예약가능일자 범위 -->
        <div class="flexBox mb15">
          <!-- 예약가능 요일 -->
          <div class="flexInner setCalendarDays">
            <label class="label colorGrey">{{locale.reservation_available_day}}</label>
            <ul class="dayList">
              <li v-for="day of info.dayOfWeek"
                :key="day.id">
                <div class="day checkbox">
                  <input type="checkbox" name="available" :id="`available_calendar_${day.id}`" :val="day.id" v-model="day.available">
                  <label :for="`available_calendar_${day.id}`">{{locale[day.id]}}</label>
                </div>
              </li>
            </ul>
          </div>
          <!-- //예약가능 요일 -->
        </div>
        <div class="flexBox">
          <!-- 예약불가일 특정 -->
          <div class="flexInner">
            <label class="label colorGrey">{{locale.reservation_disabled_day}}</label>
            <DatePicker
              color="orange"
              :attributes="disabledAttr"
              :value="null"
              :disabled-dates="disabledDateView"
              @dayclick="onDisabledDayClick">
              <template v-slot="{ togglePopover }">
                <div>
                  <button
                    class="btn btnWhite btnFull"
                    @click="togglePopover()">
                    {{locale.setting}}
                  </button>
                </div>
              </template>
            </DatePicker>
            <div class="dayList"
              v-if="info.disabledDays.length">
              <div class="dayItem"
                v-for="(day, i) in info.disabledDays"
                :key="`${i}_${day.id}`">
                {{toFormat(day.date)}}
                <button class="btnDel" @click.stop="onDisabledDayClick(day)"><span class="blind">delete</span></button>
              </div>
            </div>
          </div>
          <!-- //예약불가일 특정 -->
        </div>
      </div>
      <!-- //날짜 -->
      <!-- 시간 -->
      <div class="innerItem setReservationTime">
        <p class="innerTitle setLabel">{{locale.reservation_time_setting}}</p>
        <button type="button" class="btn btnFull btnWhite" @click="addTime">{{locale.reservation_add_time}}</button>
        <div v-if="info.time.length">
          <div class="timeList">
            <ul>
              <li v-for="(time, index) in info.time"
                :key="index"
                :class="{exist: checkTime(time)}">
                <div class="timeBox">
                  <Datetime type="time"
                    v-model="time.from"
                    input-class="input timeInput"
                    :minute-step="1"
                    @close="existTimeMessage(time)" />
                  <span>~</span>
                  <Datetime type="time"
                    v-model="time.to"
                    input-class="input timeInput"
                    :minute-step="1"
                    @close="existTimeMessage(time)" />
                  <button type="button" class="btnDel" @click="delTime(index)"></button>
                </div>
                <div class="timeLabel mt5">
                  <div class="translation">
                    <input v-model="time.label[lang.default]" type="text" class="input" @focusout="setDefaultVal('time', index, 'label')">
                    <button type="button" class="btnTranslation" :title="locale.language_specific_set" @click.stop="onLangValueOpen('time', index)">
                      <span class="blind">{{locale.language_specific_set}}</span>
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="512" height="512"><g id="outline"><path d="M71.008,183.859,99,206.25A8,8,0,0,0,112,200V176h34c-.1.146-.226.283-.329.43a136.11,136.11,0,0,0,57.883,205.109c.211.086.429.164.648.234A135.616,135.616,0,0,0,256,392a137.9,137.9,0,0,0,24-2.129V440a32.032,32.032,0,0,0,32,32H424a32.032,32.032,0,0,0,32-32V367.383a39.852,39.852,0,0,0-15.008-31.242L413,313.75A8,8,0,0,0,400,320v24H359.5c2.225-2.613,4.472-5.211,6.491-7.976.031-.04.064-.076.1-.117s.057-.067.083-.1A136.03,136.03,0,0,0,256,120a137.9,137.9,0,0,0-24,2.129V80a32.032,32.032,0,0,0-32-32H88A32.032,32.032,0,0,0,56,80v72.617A39.852,39.852,0,0,0,71.008,183.859ZM408,360a8,8,0,0,0,8-8V336.641l14.992,11.992A23.906,23.906,0,0,1,440,367.383V440a16.021,16.021,0,0,1-16,16H312a16.021,16.021,0,0,1-16-16V376a16.021,16.021,0,0,1,16-16Zm-85.725-16q1.952-7.046,3.563-14.112Q335.9,332.2,346,335.273c-2.692,3.055-5.56,5.948-8.55,8.727Zm34.063-22.282q-13.658-4.4-27.277-7.5A324.916,324.916,0,0,0,334.2,264h41.5A119.068,119.068,0,0,1,356.338,321.718Zm.145-131.214A118.789,118.789,0,0,1,375.691,248H334.2a323.384,323.384,0,0,0-5.125-50.036Q342.938,194.822,356.483,190.5Zm-10.277-13.583q-10.067,3.023-20.317,5.362-3.323-14.64-8.128-29.137A119.3,119.3,0,0,1,346.206,176.921ZM264,136.314a119.479,119.479,0,0,1,33.258,7.09,298.5,298.5,0,0,1,12.961,42.11A310.41,310.41,0,0,1,264,190.167Zm0,69.881a326.175,326.175,0,0,0,49.4-5,307.007,307.007,0,0,1,4.8,46.8H264ZM264,264H318.2a308.575,308.575,0,0,1-4.8,46.941A326.084,326.084,0,0,0,264,305.829Zm0,57.831a310.731,310.731,0,0,1,46.176,4.783q-2.089,9.087-4.726,18.071a31.955,31.955,0,0,0-25.195,28.8A118.573,118.573,0,0,1,264,375.64ZM155.512,190.512q12.942,4.15,25.833,7.111A325.253,325.253,0,0,0,176.2,248H136.309A118.879,118.879,0,0,1,155.512,190.512Zm10.257-13.577q.415-.468.838-.935h19.317c-.5,2-.951,3.96-1.406,5.941Q175.164,179.765,165.769,176.935ZM155.384,321.26A118.849,118.849,0,0,1,136.308,264h39.9a324.516,324.516,0,0,0,5.138,50.2Q168.435,317.155,155.384,321.26Zm10.259,13.609q9.494-2.819,18.891-4.982,3.207,14.038,7.67,27.719A120.364,120.364,0,0,1,165.643,334.869ZM248,375.671a121.547,121.547,0,0,1-35.183-7.794,298.271,298.271,0,0,1-12.623-41.254A302.426,302.426,0,0,1,248,321.765Zm0-69.86a332.354,332.354,0,0,0-50.989,5.142A307.941,307.941,0,0,1,192.2,264H248ZM248,248H192.2a308.706,308.706,0,0,1,4.8-47.084A325.631,325.631,0,0,0,248,206.191ZM232,144v-5.54a118.972,118.972,0,0,1,16-2.106v53.814a309.782,309.782,0,0,1-47.824-4.93q1.1-4.733,2.369-9.5A31.932,31.932,0,0,0,232,144ZM72,80A16.021,16.021,0,0,1,88,64H200a16.021,16.021,0,0,1,16,16v64a16.021,16.021,0,0,1-16,16H104a8,8,0,0,0-8,8v15.359L81.008,171.367A23.906,23.906,0,0,1,72,152.617Z"/><circle cx="144" cy="108" r="12"/><circle cx="188" cy="108" r="12"/><circle cx="100" cy="108" r="12"/><circle cx="368" cy="412" r="12"/><circle cx="412" cy="412" r="12"/><circle cx="324" cy="412" r="12"/></g></svg>
                    </button>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div v-if="info.allowedToday" class="possibleUpto mt15">
            <span class="checkbox">
              <input type="checkbox" id="possible_upto" v-model="info.possibleUpTo">
              <label for="possible_upto" class="label">{{locale.reservation_possible_upto}}</label>
            </span>
            <div class="mt5">
              <input type="text" class="input sizeS" v-model="info.possibleUpToTime" @input="inputNumber('info', 'possibleUpToTime')"> {{locale.minute}}
            </div>
          </div>
        </div>
      </div>
      <!-- //시간 -->
    </div>
    <!-- //column#2 -->
    <!-- column#3 -->
    <div data-flex="2" class="flexInner reservationSection">
      <div class="innerItem">
        <p class="innerTitle setLabel">{{locale.reservation_section_setting}}</p>
        <button type="button" class="btn btnWhite" @click="addSection">{{locale.reservation_add_section}}</button>
        <div v-if="info.section.length"
          class="reservationSeat"
          :class="{hasSection: info.section.length > 1}">
          <div class="section"
            v-for="(section, index) in info.section"
            :key="section.id">
            <!-- 자동 자리배정 (이용인원이 최대인원수에 가장 근접한 place로 배정) -->
            <div class="mb5">
              <span class="checkbox">
                <input type="checkbox"
                  :id="`auto_assign_${section.id}`"
                  :disabled="!(section.seatMap && section.seatMap.length)"
                  v-model="section.autoAssign">
                <label
                  :for="`auto_assign_${section.id}`"
                  @click="checkSeatMap(section)">
                  {{locale.reservation_auto_assign}}
                </label>
              </span>
            </div>
            <!-- //자동 자리배정 -->
            <button v-if="info.section.length > 1" type="button" class="btnDel btnDelSection" @click="delSection(section.id)"><span class="blind">X</span></button>
            <div class="sectionTitle translation mb10">
              <input v-model="section.name[lang.default]" type="text" class="input" @focusout="setDefaultVal('section', section.id, 'name')">
              <button type="button" class="btnTranslation" :title="locale.language_specific_set" @click.stop="onLangValueOpen('section', index)">
                <span class="blind">{{locale.language_specific_set}}</span>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="512" height="512"><g id="outline"><path d="M71.008,183.859,99,206.25A8,8,0,0,0,112,200V176h34c-.1.146-.226.283-.329.43a136.11,136.11,0,0,0,57.883,205.109c.211.086.429.164.648.234A135.616,135.616,0,0,0,256,392a137.9,137.9,0,0,0,24-2.129V440a32.032,32.032,0,0,0,32,32H424a32.032,32.032,0,0,0,32-32V367.383a39.852,39.852,0,0,0-15.008-31.242L413,313.75A8,8,0,0,0,400,320v24H359.5c2.225-2.613,4.472-5.211,6.491-7.976.031-.04.064-.076.1-.117s.057-.067.083-.1A136.03,136.03,0,0,0,256,120a137.9,137.9,0,0,0-24,2.129V80a32.032,32.032,0,0,0-32-32H88A32.032,32.032,0,0,0,56,80v72.617A39.852,39.852,0,0,0,71.008,183.859ZM408,360a8,8,0,0,0,8-8V336.641l14.992,11.992A23.906,23.906,0,0,1,440,367.383V440a16.021,16.021,0,0,1-16,16H312a16.021,16.021,0,0,1-16-16V376a16.021,16.021,0,0,1,16-16Zm-85.725-16q1.952-7.046,3.563-14.112Q335.9,332.2,346,335.273c-2.692,3.055-5.56,5.948-8.55,8.727Zm34.063-22.282q-13.658-4.4-27.277-7.5A324.916,324.916,0,0,0,334.2,264h41.5A119.068,119.068,0,0,1,356.338,321.718Zm.145-131.214A118.789,118.789,0,0,1,375.691,248H334.2a323.384,323.384,0,0,0-5.125-50.036Q342.938,194.822,356.483,190.5Zm-10.277-13.583q-10.067,3.023-20.317,5.362-3.323-14.64-8.128-29.137A119.3,119.3,0,0,1,346.206,176.921ZM264,136.314a119.479,119.479,0,0,1,33.258,7.09,298.5,298.5,0,0,1,12.961,42.11A310.41,310.41,0,0,1,264,190.167Zm0,69.881a326.175,326.175,0,0,0,49.4-5,307.007,307.007,0,0,1,4.8,46.8H264ZM264,264H318.2a308.575,308.575,0,0,1-4.8,46.941A326.084,326.084,0,0,0,264,305.829Zm0,57.831a310.731,310.731,0,0,1,46.176,4.783q-2.089,9.087-4.726,18.071a31.955,31.955,0,0,0-25.195,28.8A118.573,118.573,0,0,1,264,375.64ZM155.512,190.512q12.942,4.15,25.833,7.111A325.253,325.253,0,0,0,176.2,248H136.309A118.879,118.879,0,0,1,155.512,190.512Zm10.257-13.577q.415-.468.838-.935h19.317c-.5,2-.951,3.96-1.406,5.941Q175.164,179.765,165.769,176.935ZM155.384,321.26A118.849,118.849,0,0,1,136.308,264h39.9a324.516,324.516,0,0,0,5.138,50.2Q168.435,317.155,155.384,321.26Zm10.259,13.609q9.494-2.819,18.891-4.982,3.207,14.038,7.67,27.719A120.364,120.364,0,0,1,165.643,334.869ZM248,375.671a121.547,121.547,0,0,1-35.183-7.794,298.271,298.271,0,0,1-12.623-41.254A302.426,302.426,0,0,1,248,321.765Zm0-69.86a332.354,332.354,0,0,0-50.989,5.142A307.941,307.941,0,0,1,192.2,264H248ZM248,248H192.2a308.706,308.706,0,0,1,4.8-47.084A325.631,325.631,0,0,0,248,206.191ZM232,144v-5.54a118.972,118.972,0,0,1,16-2.106v53.814a309.782,309.782,0,0,1-47.824-4.93q1.1-4.733,2.369-9.5A31.932,31.932,0,0,0,232,144ZM72,80A16.021,16.021,0,0,1,88,64H200a16.021,16.021,0,0,1,16,16v64a16.021,16.021,0,0,1-16,16H104a8,8,0,0,0-8,8v15.359L81.008,171.367A23.906,23.906,0,0,1,72,152.617Z"/><circle cx="144" cy="108" r="12"/><circle cx="188" cy="108" r="12"/><circle cx="100" cy="108" r="12"/><circle cx="368" cy="412" r="12"/><circle cx="412" cy="412" r="12"/><circle cx="324" cy="412" r="12"/></g></svg>
              </button>
            </div>
            <!-- place -->
            <div class="place"
              v-for="(place, idx) in section.place"
              :key="place.placeId">
              <button v-if="section.place.length > 1" type="button" class="btnDel btnDelPlace" @click="delPlace(section.id, place.placeId)"><span class="blind">X</span></button>
              <button
                type="button"
                class="btnPlace mb10"
                :class="{disabled: place.disabled}"
                @click="setPlace(index, idx, place)">
                <span class="name">{{place.name[lang.default]}}</span>
                <span class="seats">{{place.min}} ~ {{place.max}}</span>
                <span class="count">{{place.count}}</span>
              </button>
            </div>
            <!-- //place -->
            <div class="btns sectionBtns">
              <button type="button" class="btn btnWhite" @click="setSection(section)">
                <span :class="{colorRed: diffSeatMap(section) > 0}">{{locale.reservation_individual_seat}}</span>
              </button>
              <button type="button" class="btn" @click="addPlace(index)">{{locale.reservation_add_place}}</button>
            </div>
            <div v-if="diffSeatMap(section) > 0" class="diffMessage">
              <!-- 개별 설정이 필요한 자리가 있습니다.<br>자리 설정 버튼을 눌러 확인해주세요. -->
              <p class="sysMessage">{{locale.message_reservation_diff_seat_1}}<br>{{locale.message_reservation_diff_seat_2}}</p>
            </div>
          </div>
        </div>
        <p v-else class="noData">{{locale.message_reservaion_add_section}}</p>
      </div>
    </div>
    <!-- //column#3 -->
    <!-- layer 장소 상세설정 -->
    <div v-if="detail" class="layer reservationDetail">
      <div class="inner">
        <button type="button" class="btnClose" @click="closeDetail"><span class="blind">close</span></button>
        <h2 class="layerTitle">{{detail.name[lang.default]}} {{locale.reservation_detail_setting}}</h2>
        <div>
          <div class="mb15">
            <p class="label">{{locale.reservation_place_name}}</p>
            <div class="translation">
              <input v-model="detail.name[lang.default]" type="text" class="input" @focusout="setDefaultVal('place', detail.placeId, 'name')">
              <button type="button" class="btnTranslation" :title="locale.language_specific_set" @click.stop="onLangValueOpen('detail')">
                <span class="blind">{{locale.language_specific_set}}</span>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="512" height="512"><g id="outline"><path d="M71.008,183.859,99,206.25A8,8,0,0,0,112,200V176h34c-.1.146-.226.283-.329.43a136.11,136.11,0,0,0,57.883,205.109c.211.086.429.164.648.234A135.616,135.616,0,0,0,256,392a137.9,137.9,0,0,0,24-2.129V440a32.032,32.032,0,0,0,32,32H424a32.032,32.032,0,0,0,32-32V367.383a39.852,39.852,0,0,0-15.008-31.242L413,313.75A8,8,0,0,0,400,320v24H359.5c2.225-2.613,4.472-5.211,6.491-7.976.031-.04.064-.076.1-.117s.057-.067.083-.1A136.03,136.03,0,0,0,256,120a137.9,137.9,0,0,0-24,2.129V80a32.032,32.032,0,0,0-32-32H88A32.032,32.032,0,0,0,56,80v72.617A39.852,39.852,0,0,0,71.008,183.859ZM408,360a8,8,0,0,0,8-8V336.641l14.992,11.992A23.906,23.906,0,0,1,440,367.383V440a16.021,16.021,0,0,1-16,16H312a16.021,16.021,0,0,1-16-16V376a16.021,16.021,0,0,1,16-16Zm-85.725-16q1.952-7.046,3.563-14.112Q335.9,332.2,346,335.273c-2.692,3.055-5.56,5.948-8.55,8.727Zm34.063-22.282q-13.658-4.4-27.277-7.5A324.916,324.916,0,0,0,334.2,264h41.5A119.068,119.068,0,0,1,356.338,321.718Zm.145-131.214A118.789,118.789,0,0,1,375.691,248H334.2a323.384,323.384,0,0,0-5.125-50.036Q342.938,194.822,356.483,190.5Zm-10.277-13.583q-10.067,3.023-20.317,5.362-3.323-14.64-8.128-29.137A119.3,119.3,0,0,1,346.206,176.921ZM264,136.314a119.479,119.479,0,0,1,33.258,7.09,298.5,298.5,0,0,1,12.961,42.11A310.41,310.41,0,0,1,264,190.167Zm0,69.881a326.175,326.175,0,0,0,49.4-5,307.007,307.007,0,0,1,4.8,46.8H264ZM264,264H318.2a308.575,308.575,0,0,1-4.8,46.941A326.084,326.084,0,0,0,264,305.829Zm0,57.831a310.731,310.731,0,0,1,46.176,4.783q-2.089,9.087-4.726,18.071a31.955,31.955,0,0,0-25.195,28.8A118.573,118.573,0,0,1,264,375.64ZM155.512,190.512q12.942,4.15,25.833,7.111A325.253,325.253,0,0,0,176.2,248H136.309A118.879,118.879,0,0,1,155.512,190.512Zm10.257-13.577q.415-.468.838-.935h19.317c-.5,2-.951,3.96-1.406,5.941Q175.164,179.765,165.769,176.935ZM155.384,321.26A118.849,118.849,0,0,1,136.308,264h39.9a324.516,324.516,0,0,0,5.138,50.2Q168.435,317.155,155.384,321.26Zm10.259,13.609q9.494-2.819,18.891-4.982,3.207,14.038,7.67,27.719A120.364,120.364,0,0,1,165.643,334.869ZM248,375.671a121.547,121.547,0,0,1-35.183-7.794,298.271,298.271,0,0,1-12.623-41.254A302.426,302.426,0,0,1,248,321.765Zm0-69.86a332.354,332.354,0,0,0-50.989,5.142A307.941,307.941,0,0,1,192.2,264H248ZM248,248H192.2a308.706,308.706,0,0,1,4.8-47.084A325.631,325.631,0,0,0,248,206.191ZM232,144v-5.54a118.972,118.972,0,0,1,16-2.106v53.814a309.782,309.782,0,0,1-47.824-4.93q1.1-4.733,2.369-9.5A31.932,31.932,0,0,0,232,144ZM72,80A16.021,16.021,0,0,1,88,64H200a16.021,16.021,0,0,1,16,16v64a16.021,16.021,0,0,1-16,16H104a8,8,0,0,0-8,8v15.359L81.008,171.367A23.906,23.906,0,0,1,72,152.617Z"/><circle cx="144" cy="108" r="12"/><circle cx="188" cy="108" r="12"/><circle cx="100" cy="108" r="12"/><circle cx="368" cy="412" r="12"/><circle cx="412" cy="412" r="12"/><circle cx="324" cy="412" r="12"/></g></svg>
              </button>
            </div>
          </div>
          <!-- 예약가능 인원 -->
          <div class="mb15">
            <p class="label">{{locale.reservation_possible_person}} (1~12)</p>
            <div class="minMax">
              <input type="text" class="input" v-model="detail.min" @input="inputNumber('detail', 'min')">
              <span>~</span>
              <input type="text" class="input" v-model="detail.max" @input="inputNumber('detail', 'max')">
            </div>
          </div>
          <!-- //예약가능 인원 -->
          <!-- 자리수 -->
          <div class="mb15">
            <p class="label">{{locale.reservation_seat_number}}</p>
            <input type="text" class="input inlineInput sizeS" v-model="detail.count"  @input="inputNumber('detail', 'count')" @change="setSeat">
          </div>
          <!-- //자리수 -->
          <!-- 자리별 이름 -->
          <div class="seat mb15">
            <p class="label">{{locale.reservation_seat_name}}</p>
            <div class="seatList">
              <ul>
                <li v-for="(seat, index) in detail.seat" :key="seat.seatId">
                  <div class="translation">
                    <input v-model="seat.name[lang.default]" type="text" class="input" @focusout="setDefaultVal('seat', seat.seatId, 'name')">
                    <button type="button" class="btnTranslation" :title="locale.language_specific_set" @click.stop="onLangValueOpen('seat', index)">
                      <span class="blind">{{locale.language_specific_set}}</span>
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="512" height="512"><g id="outline"><path d="M71.008,183.859,99,206.25A8,8,0,0,0,112,200V176h34c-.1.146-.226.283-.329.43a136.11,136.11,0,0,0,57.883,205.109c.211.086.429.164.648.234A135.616,135.616,0,0,0,256,392a137.9,137.9,0,0,0,24-2.129V440a32.032,32.032,0,0,0,32,32H424a32.032,32.032,0,0,0,32-32V367.383a39.852,39.852,0,0,0-15.008-31.242L413,313.75A8,8,0,0,0,400,320v24H359.5c2.225-2.613,4.472-5.211,6.491-7.976.031-.04.064-.076.1-.117s.057-.067.083-.1A136.03,136.03,0,0,0,256,120a137.9,137.9,0,0,0-24,2.129V80a32.032,32.032,0,0,0-32-32H88A32.032,32.032,0,0,0,56,80v72.617A39.852,39.852,0,0,0,71.008,183.859ZM408,360a8,8,0,0,0,8-8V336.641l14.992,11.992A23.906,23.906,0,0,1,440,367.383V440a16.021,16.021,0,0,1-16,16H312a16.021,16.021,0,0,1-16-16V376a16.021,16.021,0,0,1,16-16Zm-85.725-16q1.952-7.046,3.563-14.112Q335.9,332.2,346,335.273c-2.692,3.055-5.56,5.948-8.55,8.727Zm34.063-22.282q-13.658-4.4-27.277-7.5A324.916,324.916,0,0,0,334.2,264h41.5A119.068,119.068,0,0,1,356.338,321.718Zm.145-131.214A118.789,118.789,0,0,1,375.691,248H334.2a323.384,323.384,0,0,0-5.125-50.036Q342.938,194.822,356.483,190.5Zm-10.277-13.583q-10.067,3.023-20.317,5.362-3.323-14.64-8.128-29.137A119.3,119.3,0,0,1,346.206,176.921ZM264,136.314a119.479,119.479,0,0,1,33.258,7.09,298.5,298.5,0,0,1,12.961,42.11A310.41,310.41,0,0,1,264,190.167Zm0,69.881a326.175,326.175,0,0,0,49.4-5,307.007,307.007,0,0,1,4.8,46.8H264ZM264,264H318.2a308.575,308.575,0,0,1-4.8,46.941A326.084,326.084,0,0,0,264,305.829Zm0,57.831a310.731,310.731,0,0,1,46.176,4.783q-2.089,9.087-4.726,18.071a31.955,31.955,0,0,0-25.195,28.8A118.573,118.573,0,0,1,264,375.64ZM155.512,190.512q12.942,4.15,25.833,7.111A325.253,325.253,0,0,0,176.2,248H136.309A118.879,118.879,0,0,1,155.512,190.512Zm10.257-13.577q.415-.468.838-.935h19.317c-.5,2-.951,3.96-1.406,5.941Q175.164,179.765,165.769,176.935ZM155.384,321.26A118.849,118.849,0,0,1,136.308,264h39.9a324.516,324.516,0,0,0,5.138,50.2Q168.435,317.155,155.384,321.26Zm10.259,13.609q9.494-2.819,18.891-4.982,3.207,14.038,7.67,27.719A120.364,120.364,0,0,1,165.643,334.869ZM248,375.671a121.547,121.547,0,0,1-35.183-7.794,298.271,298.271,0,0,1-12.623-41.254A302.426,302.426,0,0,1,248,321.765Zm0-69.86a332.354,332.354,0,0,0-50.989,5.142A307.941,307.941,0,0,1,192.2,264H248ZM248,248H192.2a308.706,308.706,0,0,1,4.8-47.084A325.631,325.631,0,0,0,248,206.191ZM232,144v-5.54a118.972,118.972,0,0,1,16-2.106v53.814a309.782,309.782,0,0,1-47.824-4.93q1.1-4.733,2.369-9.5A31.932,31.932,0,0,0,232,144ZM72,80A16.021,16.021,0,0,1,88,64H200a16.021,16.021,0,0,1,16,16v64a16.021,16.021,0,0,1-16,16H104a8,8,0,0,0-8,8v15.359L81.008,171.367A23.906,23.906,0,0,1,72,152.617Z"/><circle cx="144" cy="108" r="12"/><circle cx="188" cy="108" r="12"/><circle cx="100" cy="108" r="12"/><circle cx="368" cy="412" r="12"/><circle cx="412" cy="412" r="12"/><circle cx="324" cy="412" r="12"/></g></svg>
                    </button>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <!-- //자리별 이름 -->
          <!-- disabled -->
          <div class="mb15">
            <span class="checkbox">
              <input type="checkbox" id="reservation_disabled" v-model="detail.disabled">
              <label for="reservation_disabled">{{locale.reservation_disabled}}</label>
            </span>
          </div>
          <!-- //disabled -->
        </div>
        <div class="btns">
          <button type="button" class="btn btnPrimary btnFull toUppercase" @click="applyDetail">{{locale.apply}}</button>
        </div>
      </div>
    </div>
    <!-- //layer 장소 상세설정 -->
    <!-- 언어별 세팅 -->
    <LangValue v-show="langValueLayer"
      :locale="locale"
      :langValue="langValue"
      :textarea="false"
      :title="locale.language_specific_set"
      @close="onLangValueClose" />
    <!-- //언어별 세팅 -->
    <!-- layer 섹션 설정 -->
    <SetSection v-if="setSectionLayer"
      :locale="locale"
      :lang="lang"
      :section="sectionData"
      @save="setSeatMap"
      @close="setSectionClose"
     />
    <!-- //layer 섹션 설정 -->
    <!-- 추가입력정보 -->
    <AdditionalInfo v-if="additionalInfoLayer"
      :locale="locale"
      :lang="lang"
      :additionalInfo="additionalInfo"
      @apply="applyAdditionalInfo"
      @close="setAdditionalInfo(false)"
    />
    <!-- 추가입력정보 -->
  </div>
</template>

<script>
import { DateTime } from 'luxon'
import LangValue from '@/components/Util/LangValue.vue'
import moment from 'moment/moment'
import regExp from '@/common/regExp'
import UNIQUE from '@/common/unique'
import LANG from '@/common/lang'
import UTIL from '@/common/util'
import Datetime from 'vue-datetime/src/Datetime.vue'
import SetSection from '@/components/Reservation/SettingSection.vue'
import SetLanguageValue from '../Util/SetLanguageValue.vue'
import AdditionalInfo from './AdditionalInfo.vue'


export default {
  name: 'ReservationItem',
  props: [
    'locale',
    'lang',
    'info'
  ],
  components: {
    LangValue,
    Datetime,
    SetSection,
    SetLanguageValue,
    AdditionalInfo
  },
  computed: {
    disabledAttr () {
      const disabledDates = this.info.disabledDays.map(x => x.date)
      return disabledDates.map(x => {
        return {
          highlight: true,
          dates: x
        }
      })
    },
    disabledDateView () {
      const rangeNum = Number(regExp.numberOnly(this.info.range))
      const range = moment().add(rangeNum + 1, 'days').toISOString()
      const yesterday = moment().add(-1, 'days').toISOString()
      const weekday = this.info.dayOfWeek.filter(x => !x.available).map(x => x.weekday)
      const disabledDays = this.info.disabledDays.map(x => x.id)
      const allowedToday = this.info.allowedToday
      let dates = [
        { weekdays: weekday },
        { start: null, end: yesterday },
        { start: range, end: null }
      ]
      if (disabledDays.length) {
        disabledDays.forEach(function (x) {
          dates.push(new Date(x))
        })
      }
      if (!allowedToday) {
        dates.push(new Date())
      }
      return dates
    },
    dateFormat () {
      return this.$store.getters['setting/getDateFormat']
    }
  },
  watch: {
    'info.additionalInfo': {
      immediate: true,
      deep: true,
      handler (value) {
        this.isSyncing = true
        this.additionalInfo = this._.cloneDeep(value || [])
        this.$nextTick(() => {
          this.isSyncing = false
        })
      }
    },
    additionalInfo: {
      deep: true,
      handler (data) {
        if (this.isSyncing) return
        this.$emit('updateAdditionalInfo', data)
      }
    }
  },
  data () {
    return {
      isSyncing: false,
      sectionData: null,
      setSectionLayer: false,
      detail: null,
      detailTarget: null,
      langValueLayer: false,
      langValue: {},
      langTarget: '',
      placeInfo: {
        name: this.$store.getters['setting/getLangValues'](),
        placeId: UNIQUE.mid(),
        min: 2,
        max: 4,
        count: 1,
        seat: [{
          seatId: `${UNIQUE.mid()}_1`,
          name: this.$store.getters['setting/getLangValues']('1')
        }],
        disabled: false
      },
      additionalInfo: this._.cloneDeep(this.info.additionalInfo || []),
      additionalInfoLayer: false
    }
  },
  methods: {
    setUserInfo (input) {
      if (input === 'bookerTelOrEmail') {
        if (this.info.bookerTelOrEmail) {
          this.info.bookerEmail = false
          this.info.bookerTel = false
        }
      } else {
        if (this.info.bookerEmail || this.info.bookerTel) {
          this.info.bookerTelOrEmail = false
        }
      }
    },
    onDisabledDayClick (day) {
      const idx = this.info.disabledDays.findIndex(d => d.id === day.id)
      if (idx >= 0) {
        this.info.disabledDays.splice(idx, 1)
      } else {
        this.info.disabledDays.push({
          id: day.id,
          date: day.date,
          iso: day.date.toISOString()
        })
      }
    },
    toFormat (date) {
      const iso = typeof (date) === 'string' ? date : date.toISOString()
      return DateTime.fromISO(iso).toFormat(this.dateFormat)
    },
    addTime () {
      const time = {
        from: moment().set({ hour: 12, minute: 0 }).toISOString(),
        to: moment().set({ hour: 14, minute: 0 }).toISOString(),
        label: this.$store.getters['setting/getLangValues']()
      }
      this.info.time.push(time)
    },
    delTime (index) {
      if (window.confirm(this.locale.confirm_delete_time)) {
        this.info.time = this.info.time.filter((x, i) => i !== index)
      }
    },
    checkTime (time) { // 중복된 시간이 존재하는지 체크
      const existTime = this.info.time.filter(x => timeFormat(x.from) === timeFormat(time.from) && timeFormat(x.to) === timeFormat(time.to)).length > 1
      function timeFormat (iso) {
        return moment(iso).format('HHmm')
      }
      return existTime
    },
    // 설정된 자리 정보가 없습니다.\n먼저 자리 설정을 해주세요.
    checkSeatMap (section) {
      if (!(section.seatMap && section.seatMap.length)) {
        alert(`${this.locale.alert_nodata_reservation_seatmap_1}\n${this.locale.alert_nodata_reservation_seatmap_2}`)
      }
    },
    existTimeMessage (time) {
      const existTime = this.checkTime(time)
      if (existTime) {
        // 동일한 예약시간이 존재합니다.\n예약시간은 하나만 적용되며 중복된 시간은 저장 후 삭제됩니다.
        alert(`${this.locale.alert_reservation_exist_time_1}\n${this.locale.alert_reservation_exist_time_2}`)
      }
    },
    inputNumber (info, key) {
      const raw = regExp.numberOnly(this[info][key])
      if (raw === '') {
        this[info][key] = ''
        return
      }
      let value = key === 'cancelDay'
        ? Number(raw)
        : parseInt(raw)

      if (key === 'min') {
        value = value <= 1 ? 1 : value
      } else if (key === 'max') {
        value = value >= 12 ? 12 : value
      }
      this[info][key] = value
    },
    setDefaultVal (tar, id, data) {
      const defaultLang = this.lang.default
      let fillLangs
      let target
      if (tar === 'section') {
        target = this.info.section.find(x => x.id === id)
      } else if (tar === 'place') {
        target = this.detail
      } else if (tar === 'seat') {
        target = this.detail.seat.find(x => x.seatId === id)
      } else if (tar === 'time') {
        target = this.info.time.find((x, i) => i === id)
      } else {
        target = this.info
      }
      fillLangs = UTIL.fillLangs(target[data], target[data][defaultLang])
      target[data] = fillLangs
    },
    onLangValueOpen (setting, index) { // setting: section, detail, seat
      const target = setTarget(setting, index)
      function setTarget (tar, i) {
        let result = 'name'
        if (tar) {
          if (tar === 'section') {
            result = `section|${i}`
          } else if (tar === 'seat') {
            result = `seat|${i}`
          } else if (tar === 'time') {
            result = `time|${i}`
          } else {
            result = tar
          }
        }
        return result
      }
      this.langTarget = target
      this.langValueLayer = true
      if (setting) {
        if (setting === 'section') {
          this.langValue = this.info.section[index].name
        } else if (setting === 'detail') {
          this.langValue = this.detail.name
        } else if (setting === 'info') {
          this.langValue = this.info.infoTxt
        } else if (setting === 'seat') {
          this.langValue = this.detail.seat[index].name
        } else if (setting === 'time') {
          this.langValue = this.info.time[index].label
        }
      } else {
        this.langValue = this.info.name
      }
      // this.langValue = setting
      //   ? setting === 'section'
      //     ? this.info.section[index].name
      //     : this.detail.name
      //   : this.info.name
    },
    onLangValueClose () {
      const target = this.langTarget
      const index = target.split('|')[1]
      if (target.includes('section')) {
        this.info.section[index].name = this.langValue
      } else if (target === 'detail') {
        this.detail.name = this.langValue
      } else if (target === 'info') {
        this.info.infoTxt = this.langValue
      } else if (target.includes('section')) {
        this.detail.seat[index].name = this.langValue
      } else if (target === 'name') {
        this.info.name = this.langValue
      } else if (target === 'time') {
        this.info.time[index].label = this.langValue
      }
      this.langTarget = null
      this.langValueLayer = false
      this.langValue = {}
    },
    addSection () {
      const sId = UNIQUE.mid()
      const pId = UNIQUE.mid()
      const info = {
        name: this.$store.getters['setting/getLangValues'](),
        id: sId,
        autoAssign: true,
        showPlaceName: true,
        showSeatName: true,
        place: [{ ...this._.cloneDeep(this.placeInfo), placeId: pId }]
      }
      info.name[this.lang.default] = 'New Section'
      info.place[0].name[this.lang.default] = 'New Place'
      info.place[0].seat[0].seatId = `${pId}_1`
      this.info.section.push(info)
    },
    delSection (id) {
      if (window.confirm(this.locale.confirm_delete_reservation_section)) {
        this.info.section = this.info.section.filter(x => x.id !== id)
      }
    },
    addPlace (index) {
      const pId = UNIQUE.mid()
      const place = { ...this._.cloneDeep(this.placeInfo), placeId: pId }
      place.name[this.lang.default] = 'New Place'
      place.seat[0].seatId = `${pId}_1`
      this.info.section[index].place.push(place)
    },
    delPlace (sId, pId) {
      if (window.confirm(this.locale.confirm_delete_reservation_place)) {
        const section = this.info.section.find(x => x.id === sId)
        section.place = section.place.filter(x => x.placeId !== pId)
        section.seatMap = section.seatMap.filter(x => x.placeId !== pId)
      }
    },
    setSection (section) {
      this.setSectionLayer = true
      this.sectionData = this._.cloneDeep(section)
    },
    setSeatMap (data) {
      const sectionId = this.sectionData.id
      this.info.section.find(x => x.id === sectionId).seatMap = data.seats
      this.info.section.find(x => x.id === sectionId).seatObj = data.objects
      this.info.section.find(x => x.id === sectionId).showPlaceName = data.showPlaceName
      this.info.section.find(x => x.id === sectionId).showSeatName = data.showSeatName
      this.setSectionClose()
    },
    setSectionClose () {
      this.setSectionLayer = false
      this.sectionData = null
    },
    setPlace (index, idx, place) {
      this.detailTarget = `${index}|${idx}`
      this.detail = this._.cloneDeep(place)
    },
    setSeat (e) {
      const value = e.target.value
      const count = Number(regExp.numberOnly(value))
      const diff = count - this.detail.seat.length
      if (diff > 0) {
        for (let i = 0; i < count; i++) {
          const seat = this.detail.seat[i]
          if (!seat) {
            this.detail.seat.push({
              seatId: `${this.detail.placeId}_${i + 1}`,
              name: LANG.valueObj(`${i + 1}`)
            })
          }
        }
      } else {
        this.detail.seat.splice(diff)
      }
    },
    closeDetail () {
      if (window.confirm(this.locale.confirm_cancel_reservation_place)) {
        this.detailTarget = null
        this.detail = null
      }
    },
    applyDetail (place) {
      if (window.confirm(this.locale.confirm_apply_reservation_detail)) {
        const index = this.detailTarget.split('|')[0]
        const idx = this.detailTarget.split('|')[1]
        this.info.section[index].place[idx] = this.detail
        this.detailTarget = null
        this.detail = null
      }
    },
    diffSeatMap (section) {
      // flatten place's seat like seatMap
      function flattenSeat (place) {
        let arr = []
        for (let i = 0; i < place.length; i++) {
          const p = place[i]
          for (let j = 0; j < p.seat.length; j++) {
            const s = p.seat[j]
            arr.push({
              placeId: p.placeId,
              seatId: s.seatId
            })
          }
        }
        return arr
      }
      // flatten seat && seatmap isEqual?
      function diff (place, seatMap) {
        const seats = flattenSeat(place)
        return seats.filter(seat => {
          return !seatMap.find(x => x.placeId === seat.placeId && x.seatId === seat.seatId)
        }).length
      }
      if (!section.autoAssign && section.place && section.seatMap) {
        return diff(section.place, section.seatMap)
      }
    },
    updateAdditionalInfo () {
      this.$emit('updateAdditionalInfo', this.additionalInfo)
    },
    setAdditionalInfo (isOpen) {
      this.additionalInfoLayer = isOpen
    },
    applyAdditionalInfo (data) {
      this.additionalInfo = data
      this.$emit('updateAdditionalInfo', this.additionalInfo)
      this.setAdditionalInfo(false)
    }
  }
}
</script>

<style lang="scss" scoped>
.flexBox {
  flex: 1;
  overflow: hidden;
  .flexInner {
    overflow: auto;
    max-height: 100%;
  }
  .innerItem {
    margin-bottom: 0;
    & + .innerItem {
      margin-top: 30px;
    }
  }
  .reservationSection .innerItem {
    min-height: 100%;
  }
}
.sectionBtns {
  display: flex;
  .btn {
    flex: 1;
    min-width: 0;
    padding-left: 5px;
    padding-right: 5px;
    & + .btn {
      margin-left: 4px;
    }
  }
}
.diffMessage {
  .sysMessage {
    margin-top: 0.5em;
    color: $color-red;
  }
}
.additionalInfoItem {
  position: relative;
  padding: 12px;
  border-radius: 8px;
  border: 1px solid $color-lgrey2;
  background-color: $bg-default;
  & + .additionalInfoItem {
    margin-top: 10px;
  }
  .btnDel {
    position: absolute;
    top: 0;
    right: 0;
    width: 30px;
    height: 30px;
    background: url('~@/assets/img/ico_close_black.svg') 50% 50% / 12px no-repeat;
  }
}
</style>
